import Black from '../../assets/betprofessor/fonts/Roboto-Black.ttf';
import BlackItalic from '../../assets/betprofessor/fonts/Roboto-BlackItalic.ttf';
import Bold from '../../assets/betprofessor/fonts/Roboto-Bold.ttf';
import BoldItalic from '../../assets/betprofessor/fonts/Roboto-BoldItalic.ttf';

import ExtraLight from '../../assets/betprofessor/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '../../assets/betprofessor/fonts/Roboto-ThinItalic.ttf';
import Light from '../../assets/betprofessor/fonts/Roboto-Light.ttf';
import LightItalic from '../../assets/betprofessor/fonts/Roboto-LightItalic.ttf';
import Regular from '../../assets/betprofessor/fonts/Roboto-Regular.ttf';
import Italic from '../../assets/betprofessor/fonts/Roboto-Italic.ttf';
import SemiBold from '../../assets/betprofessor/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '../../assets/betprofessor/fonts/Roboto-MediumItalic.ttf';

import PatrickHand from '../../assets/betprofessor/fonts/PatrickHand-Regular.ttf';
import FredokaLight from '../../assets/betprofessor/fonts/Fredoka-Light.ttf';
import FredokaRegular from '../../assets/betprofessor/fonts/Fredoka-Regular.ttf';
import FredokaMedium from '../../assets/betprofessor/fonts/Fredoka-Medium.ttf';
import FredokaSemiBold from '../../assets/betprofessor/fonts/Fredoka-SemiBold.ttf';
import FredokaBold from '../../assets/betprofessor/fonts/Fredoka-Bold.ttf';
import DreadfulRegular from '../../assets/betprofessor/fonts/Dreadful-Regular.ttf';

export const fontFace = `
  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLight}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${Light}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 300;
    font-display: swap;
    src: url('${LightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Regular}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('${Italic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${Bold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url('${BoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${Black}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 900;
    font-display: swap;
    src: url('${BlackItalic}') format('opentype');
  }
  @font-face {
    font-family: 'PatrickHand';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${PatrickHand}') format('opentype');
  }

  @font-face {
    font-family: 'fredoka';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${FredokaLight}') format('opentype');
  }
  @font-face {
    font-family: 'fredoka';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${FredokaRegular}') format('opentype');
  }
  @font-face {
    font-family: 'fredoka';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('${FredokaMedium}') format('opentype');
  }
  @font-face {
    font-family: 'fredoka';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('${FredokaSemiBold}') format('opentype');
  }
  @font-face {
    font-family: 'fredoka';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${FredokaBold}') format('opentype');
  }

  @font-face {
    font-family: 'dreadful';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${DreadfulRegular}') format('opentype');
  }
`;
